import { useEffect, useMemo } from "react";
import type { Control } from "./alk-maps";
import { inject } from "./ng";

export function useControl<T extends Control>(controlFactory: () => T) {
	const control = useMemo(controlFactory, []);

	useEffect(() => {
		const map = inject("mapService").getMap();
		if (!map.div.isConnected) {
			return;
		}
		map.addControl(control);
		return () => {
			map.removeControl(control);
		};
	}, [control]);

	return control;
}
